<div class="pageheader">
  <div class="page-title">
    <h1>Status event subscriptions</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Status event subscriptions log'">
        <app-change-log-link-entity type="StatusEventSubscription"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='subscriptions' [bizSetAllowColumnReordering]="false" [bizSetPager]="false"
  (onEditingStart)="onEditingStart($event)" (onRowValidating)="onRowValidating($event)" (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)"
  (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)">

  <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
    <dxo-popup title="Status event subscription" [showTitle]="true"></dxo-popup>
  </dxo-editing>
  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="IsEnabled" caption="Enabled" dataType="boolean">
  </dxi-column>

  <dxi-column dataField="StatusNames" caption="Status" editCellTemplate="statusTypesTemplate" [calculateFilterExpression]="calculateArrayFilterExpression">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxo-header-filter [dataSource]="getStatusNamesHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="PartnerIn" caption="Partner in" dataType="string" calculateDisplayValue="PartnerIn.PartnerName" editCellTemplate="partnerEditTemplate"
    [calculateFilterExpression]="calculateFilterExpression">
    <dxo-header-filter [dataSource]="getPartnerInHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="PartnerOut" caption="Partner out" dataType="string" calculateDisplayValue="PartnerOut.PartnerName" editCellTemplate="partnerEditTemplate"
    [calculateFilterExpression]="calculateFilterExpression">
    <dxo-header-filter [dataSource]="getPartnerOutHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="DocumentTypeId" caption="Document type" dataType="string" editCellTemplate="documentTypeDropDown">
    <dxo-lookup [dataSource]="documentTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    <dxo-header-filter [dataSource]="getDocumentTypeHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="PartnerSystemId" caption="Partner system" dataType="string" editCellTemplate="partnerSystemDropDown">
    <dxo-lookup [dataSource]="partnerSystems" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    <dxo-header-filter [dataSource]="getPartnerSystemHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="ArtifactId" caption="Artifact" editCellTemplate="artifactEditTemplate">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxo-lookup [dataSource]="artifacts" valueExpr="ArtifactId" displayExpr="Name"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="StakeholderId" caption="Stakeholder" dataType="string" editCellTemplate="stakeholderDropDown">
    <dxo-lookup [dataSource]="stakeholders" valueExpr="StakeholdersId" displayExpr="Name"></dxo-lookup>
    <dxo-header-filter [dataSource]="getStakeholderHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter
  [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.subscriptions, 'CreatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>

  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter
  [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.subscriptions, 'UpdatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="StatusEventSubscription" [id]="cell.data.SubscriptionsId"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'artifactEditTemplate'">
    <app-developer-artifact-assembly-picker [assemblyTypes]="['StatusEventHandler', 'StatusEventHandler2']" [selectedArtifactId]="cellInfo.value"
      (selectedArtifactIdChange)="selectedArtifactIdChange($event, cellInfo)">
    </app-developer-artifact-assembly-picker>
    @if (statusEventHandlerDataFields.length) {
      <ep-datafield-group-container [formValidationGroup]="statusEventHandlerFormGroup" [showError]="true"
        [datafieldGroups]="statusEventHandlerDataFields" [isAlwaysEditable]="true" [numberOfColumns]="2">
      </ep-datafield-group-container>
    }
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'partnerEditTemplate'">
    <ep-partner-selector [selectedPartner]="cellInfo.value" (selectedPartnerChange)="onPartnerChanged($event, cellInfo)">
    </ep-partner-selector>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'statusTypesTemplate'">
    <dx-tag-box [dataSource]="subscriptionStatusTypes" [showSelectionControls]="true" [value]="cellInfo.value" (onValueChanged)="onValueChangedForStatustype($event, cellInfo)"
      (onCustomItemCreating)="onCustomItemCreating($event)" displayExpr="StatusTypeName" valueExpr="StatusTypeName" [acceptCustomValue]="true" customItemCreateEvent="change"
      tagTemplate="tagTemplate">

      <div *dxTemplate="let tagData of 'tagTemplate'" class="dx-tag-content" [ngStyle]="{'background-color':tagData.StatusTypesId === -1 ? 'lightsteelblue' : '' }">
        <span>{{tagData.StatusTypeName}}</span>
        <div class="dx-tag-remove-button"></div>
      </div>
    </dx-tag-box>
    <div [ngStyle]="{'padding-top':'5px'}">Select a document status or manually type a technical status</div>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'documentTypeDropDown'">
    <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="documentTypes" [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id" contentTemplate="contentTemplate">
      <div *dxTemplate="let e of 'contentTemplate'">
        <dx-data-grid [dataSource]="documentTypes" [remoteOperations]="true" [height]="250" [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true" [focusedRowKey]="cellInfo.value"
          [hoverStateEnabled]="true" keyExpr="Id" (onSelectionChanged)="onSelectionChangedForDocumentType($event.selectedRowKeys, cellInfo, e.component)">
          <dxi-column dataField="Name" sortOrder="asc"></dxi-column>
          <dxi-column dataField="Description"></dxi-column>
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-selection mode="single"></dxo-selection>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'stakeholderDropDown'">
    <select class="form-control" [ngModel]="cellInfo.value" (ngModelChange)="onValueChangedForStakeholder($event, cellInfo)">
      <option [ngValue]="0">Select...</option>
      @for (e of stakeholders; track e) {
        <option [ngValue]="e.StakeholdersId" [title]="e.Description">{{e.Name}}</option>
      }
    </select>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'partnerSystemDropDown'">
    <select class="form-control" [ngModel]="cellInfo.value" (ngModelChange)="onValueChangedForPartnerSystem($event, cellInfo)">
      <option [ngValue]="0">Select...</option>
      @for (e of partnerSystems; track e) {
        <option [ngValue]="e.Id" [title]="e.Name">{{e.Name}}</option>
      }
    </select>
  </ng-container>

</dx-data-grid>
